(() => {
  if (window.PileniumWishlist) return;
  const key = 'pilenium_wishlist';
  const legacyKey = 'pilWish';
  const identityKey = 'pilenium_wishlist_ids';
  const labels = window.PileniumWishlistConfig || {};
  let items = [];
  let identities = Object.create(null);

  function handle(value) {
    if (typeof value !== 'string') return '';
    value = value.trim().split('/products/').pop().split(/[?#]/)[0];
    try { value = decodeURIComponent(value); } catch (_) {}
    return value && !/[\/\s]/.test(value) ? value : '';
  }

  function list(value) {
    const source = Array.isArray(value) ? value : value && typeof value === 'object' ? Object.keys(value).filter((name) => value[name]) : [];
    return [...new Set(source.map(handle).filter(Boolean))];
  }

  function parse(value) {
    try { return list(JSON.parse(value || '[]')); } catch (_) { return null; }
  }

  function read(name) {
    try { return parse(localStorage.getItem(name)); } catch (_) { return null; }
  }

  function readIdentities(value) {
    const result = Object.create(null);
    try {
      const values = JSON.parse(value || '{}');
      if (values && typeof values === 'object' && !Array.isArray(values)) {
        Object.keys(values).forEach((name) => {
          const normalized = handle(name), id = String(values[name]);
          if (normalized && /^\d+$/.test(id)) result[normalized] = id;
        });
      }
    } catch (_) {}
    return result;
  }

  function sameProduct(first, second) {
    return first === second || Boolean(identities[first] && identities[first] === identities[second]);
  }

  function distinct(value) {
    const seen = new Set();
    return list(value).filter((name) => {
      const identity = identities[name] ? 'id:' + identities[name] : 'handle:' + name;
      if (seen.has(identity)) return false;
      seen.add(identity);
      return true;
    });
  }

  function register(name, id) {
    name = handle(name);
    id = String(id || '');
    if (name && /^\d+$/.test(id)) identities[name] = id;
  }

  function persist() {
    const legacy = Object.create(null);
    items.forEach((name) => { legacy[name] = 1; });
    [[key, JSON.stringify(items)], [legacyKey, JSON.stringify(legacy)], [identityKey, JSON.stringify(identities)]].forEach(([name, value]) => {
      try { if (localStorage.getItem(name) !== value) localStorage.setItem(name, value); } catch (_) {}
    });
  }

  function buttonHandle(button) {
    return handle(button.getAttribute('data-pil-wish') || button.getAttribute('data-pilenium-wish-handle') || (button.matches('.pil-pdp__wishlist') ? labels.productHandle || window.location.pathname : ''));
  }

  function paint() {
    const buttons = document.querySelectorAll('[data-pil-wish],.pil-pdp__wishlist');
    buttons.forEach((button) => register(buttonHandle(button), button.getAttribute('data-pil-wish-id') || (button.matches('.pil-pdp__wishlist') ? labels.productId : '')));
    items = distinct(items);
    persist();
    buttons.forEach((button) => {
      const name = buttonHandle(button);
      if (!name) return;
      const saved = items.some((item) => sameProduct(item, name));
      button.classList.toggle('is-saved', saved);
      button.classList.toggle('pil-wish-on', saved);
      button.setAttribute('aria-pressed', String(saved));
      const label = saved ? labels.added : labels.add;
      if (label) button.setAttribute('aria-label', label.trim());
      if (button.matches('.pil-pdp__wishlist') && label) {
        const node = Array.from(button.childNodes).find((child) => child.nodeType === 3 && child.nodeValue.trim());
        if (node) node.nodeValue = label;
      }
    });
    document.querySelectorAll('[data-pil-wish-count]').forEach((node) => {
      node.textContent = String(items.length);
      node.hidden = items.length === 0;
      node.closest('.pil-act--wish')?.classList.toggle('is-on', items.length > 0);
    });
  }

  function notify() {
    paint();
    document.dispatchEvent(new CustomEvent('pilenium:wishlist', { detail: { count: items.length, items: items.slice() } }));
    paint();
  }

  function set(value) {
    items = distinct(value);
    persist();
    notify();
    return items.slice();
  }

  function toggle(value) {
    const name = handle(value);
    if (!name) return false;
    const saved = !items.some((item) => sameProduct(item, name));
    set(saved ? [...items, name] : items.filter((item) => !sameProduct(item, name)));
    return saved;
  }

  function animate(button, saved) {
    button.classList.add('pil-cc__wish--pulse');
    window.setTimeout(() => button.classList.remove('pil-cc__wish--pulse'), 360);
    const icon = button.querySelector('span,svg');
    icon?.animate?.([{ transform: 'scale(1)' }, { transform: 'scale(1.45)' }, { transform: 'scale(1)' }], { duration: 340, easing: 'ease-out' });
    if (!saved) return;
    try { window.navigator.vibrate?.(10); } catch (_) {}
    if (button.matches('.pil-pdp__wishlist') && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      try {
        const Audio = window.AudioContext || window.webkitAudioContext;
        if (!Audio) return;
        const audio = window.__pilAC || (window.__pilAC = new Audio());
        if (audio.state === 'suspended') audio.resume().catch(() => {});
        const tone = audio.createOscillator(), gain = audio.createGain(), now = audio.currentTime;
        tone.type = 'sine';
        tone.frequency.value = 1046.5;
        gain.gain.setValueAtTime(0.0001, now);
        gain.gain.exponentialRampToValueAtTime(0.05, now + 0.012);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.5);
        tone.connect(gain);
        gain.connect(audio.destination);
        tone.start(now);
        tone.stop(now + 0.55);
      } catch (_) {}
    }
  }

  try { identities = readIdentities(localStorage.getItem(identityKey)); } catch (_) {}
  register(labels.productHandle, labels.productId);
  items = distinct([...(read(key) || []), ...(read(legacyKey) || [])]);
  window.PileniumWishlist = {
    get: () => items.slice(),
    has: (value) => items.some((item) => sameProduct(item, handle(value))),
    id: (value) => identities[handle(value)] || '',
    remember: (value, id) => {
      register(value, id);
      const previous = items.join('\n');
      items = distinct(items);
      persist();
      if (items.join('\n') !== previous) notify();
      else paint();
    },
    toggle,
    remove: (value) => set(items.filter((item) => !sameProduct(item, handle(value)))),
    refresh: paint,
  };
  persist();
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-pil-wish],.pil-pdp__wishlist');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const name = buttonHandle(button);
    register(name, button.getAttribute('data-pil-wish-id') || (button.matches('.pil-pdp__wishlist') ? labels.productId : ''));
    if (name) animate(button, toggle(name));
  }, true);
  window.addEventListener('storage', (event) => {
    if (event.key === identityKey) {
      Object.assign(identities, readIdentities(event.newValue));
      items = distinct(items);
      notify();
      return;
    }
    if (event.key !== key && event.key !== legacyKey && event.key !== null) return;
    const incoming = event.key === null ? [] : parse(event.newValue);
    if (incoming === null) return;
    items = distinct(incoming);
    persist();
    notify();
  });
  window.addEventListener('pageshow', paint);
  document.addEventListener('shopify:section:load', paint);
  document.addEventListener('DOMContentLoaded', notify, { once: true });
  notify();
})();
